import React, { FunctionComponent } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { DateTimePeriod, EventPositionDto, TravelRangeDto } from 'stores/events/events-store';
//import './new-events-support-details.style.less';
import { /*Checkbox,*/ Icon /*, Input*/ } from 'semantic-ui-react';
//import PeriodInput from 'widgets/form/period-input';
import TailwindPeriodInput from 'widgets/form/period-input-tw';
import moment from 'moment';
import { IdentityService } from 'services/identity-service';
import { container } from 'inversify.config';
import { DatesRangeInput } from 'widgets/form/datesRangeInput';
import { /*EventFormStore,*/ EventFormViewModel } from 'stores/events/event-form-store';

interface TailwindEventNewModelPositionComponentProps extends WithTranslation {
  eventNewModelPositions: EventPositionDto[];
  isHideEditButton: boolean;
  readonly: boolean;
  datesChangeHandler: ({ from, to }: DateTimePeriod, idx: number, travelDays: boolean) => void;
  handleTravelDays: (index: number, property: keyof TravelRangeDto, { from, to }: DateTimePeriod) => void;
  inputChangeHandler: (property: string, value: any, idx: number) => void;
  changeEmployeeHandler: (idx: number) => void;
  //formatInput: (e: any) => boolean;
  removeEventNewModelPositionHandler: (index: number) => void;
  supportPositionId: string;
  machine: string;
  pattern: string;
  event: EventFormViewModel;
}

const TailwindEventNewModelPositionComponent: FunctionComponent<TailwindEventNewModelPositionComponentProps> = props => {
  const identityService: IdentityService = container.get(IdentityService);
  const isAdminPocOrPlanner = (): boolean => {
    return IdentityService.isAdminPocOrPlanner(identityService.getUserInfo());
  };

  const isInstructor = (): boolean => {
    return IdentityService.isInstructor(identityService.getUserInfo());
  };

  const canChangePosition = (userId: string): boolean => {
    const currentUser = identityService.getUserInfo();
    return isAdminPocOrPlanner() || (isInstructor() && currentUser && currentUser.userId === userId);
  };

  const handleNoTravel = (index: number, value: boolean) => {
    inputChangeHandler('noTravel', value, index);
  };

  const {
    eventNewModelPositions,
    readonly,
    isHideEditButton,
    datesChangeHandler,
    handleTravelDays,
    inputChangeHandler,
    changeEmployeeHandler,
    //formatInput,
    removeEventNewModelPositionHandler,
    supportPositionId,
    machine,
    pattern,
    event,
    t
  } = props;

  const { status } = event;

  return (
    <div>
      {(eventNewModelPositions || []).map((ep, idx) => {
        const { actualCost, actualHours, actualDays, endDate, startDate, travelDays, user, userId, plannedDays, noTravel } = ep;
        const employeeRole = user.roles.find(x => x.role.name === 'Employee');
        const employeeLocation = employeeRole?.location?.location || t('LOCATION');
        return (
          <>
            <div key={idx} className="bg-gray-50 rounded shadow p-4 mb-4 flex flex-col gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">{t('Employee')}</label>
                <input className="w-full border border-gray-300 rounded px-2 py-1" disabled value={user.lastName + ', ' + user.firstName} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">{t('SAP ID')}</label>
                <input className="w-full border border-gray-300 rounded px-2 py-1" disabled value={user.employeeId} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">{t('Position Code')}</label>
                <input className="w-full border border-gray-300 rounded px-2 py-1" disabled value={user.positionCode?.code || ''} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">{t('Location')}</label>
                <input className="w-full border border-gray-300 rounded px-2 py-1" disabled value={employeeLocation} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">{t('Line Manager')}</label>
                <input className="w-full border border-gray-300 rounded px-2 py-1" disabled value={user.lineManager} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">{t('Dates')}</label>
                <TailwindPeriodInput
                  id={'info-support-details-dates-' + supportPositionId + pattern + machine + +userId + idx}
                  readOnly={readonly || !canChangePosition(userId)}
                  onChange={period => datesChangeHandler(period, idx, false)}
                  value={{ from: startDate, to: endDate }}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">{t('Planned Days')}</label>
                <input
                  className="w-full border border-gray-300 rounded px-2 py-1"
                  type="number"
                  disabled
                  onChange={value => inputChangeHandler('plannedDays', value, idx)}
                  value={
                    ((plannedDays === null || plannedDays === undefined) &&
                    startDate &&
                    endDate &&
                    moment(startDate).isSameOrBefore(moment(endDate))
                      ? inputChangeHandler('plannedDays', moment(endDate).diff(moment(startDate), 'days') + 1, idx)
                      : plannedDays || 0) || 0
                  }
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">{t('Actual Days')}</label>
                <div className="flex items-center gap-2">
                  <input
                    className="w-full border border-gray-300 rounded px-2 py-1"
                    type="number"
                    //label={{ basic: true, content: 'w/d' }}
                    disabled={readonly || !canChangePosition(userId)}
                    onChange={value => inputChangeHandler('actualDays', value, idx)}
                    value={actualDays}
                  />
                  <span className="whitespace-nowrap">w/d</span>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">{t('Actual Hours')}</label>
                <div className="flex items-center gap-2">
                  <input
                    className="w-full border border-gray-300 rounded px-2 py-1"
                    // labelPosition="right"
                    type="number"
                    // label={{ basic: true, content: 'h' }}
                    disabled={readonly || !canChangePosition(userId)}
                    onChange={value => inputChangeHandler('actualHours', value, idx)}
                    value={actualHours}
                  />
                  <span className="whitespace-nowrap">h</span>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">{t('Actual Cost')}</label>
                <div className="flex items-center gap-2">
                  <input
                    className="w-full border border-gray-300 rounded px-2 py-1"
                    //label={{ basic: true, content: '$' }}
                    type="number"
                    disabled={readonly || !canChangePosition(userId)}
                    onChange={value => inputChangeHandler('actualCost', value, idx)}
                    value={actualCost}
                  />
                  <span className="whitespace-nowrap">$</span>
                </div>
              </div>
              {status.toString() !== 'Draft' && (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t('Travel Days')}</label>
                    <DatesRangeInput
                      className="travel-days__departure"
                      dontUseRedClearIconColor
                      iconPosition="right"
                      readOnly={readonly}
                      fromValue={travelDays?.departure?.from}
                      toValue={travelDays?.departure?.to}
                      onChange={(from, to) => handleTravelDays(idx, 'departure', { from, to })}
                      placeholder={t('Departure')}
                      clearable
                      icon={false}
                      allowSameEndDate
                      getEveryChange
                    />
                    <DatesRangeInput
                      className="travel-days__arrival"
                      dontUseRedClearIconColor
                      iconPosition="right"
                      readOnly={readonly}
                      fromValue={travelDays?.arrival?.from}
                      toValue={travelDays?.arrival?.to}
                      onChange={(from, to) => handleTravelDays(idx, 'arrival', { from, to })}
                      placeholder={t('Arrival')}
                      clearable
                      icon={false}
                      allowSameEndDate
                      getEveryChange
                    />
                  </div>
                  <div className="flex items-center gap-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t('No Travel')}</label>
                    <div className="flex items-center">
                      <input
                        disabled={readonly}
                        id="default-checkbox"
                        type="checkbox"
                        value=""
                        checked={noTravel}
                        className="w-4 h-4 text-black-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        onChange={data => handleNoTravel(idx, data.target.checked)}
                      />
                    </div>
                  </div>
                </>
              )}
              {isAdminPocOrPlanner() && !readonly && !isHideEditButton && <Icon onClick={() => changeEmployeeHandler(idx)} name="edit" />}
              {isAdminPocOrPlanner() && !readonly && !isHideEditButton && (
                <Icon onClick={() => removeEventNewModelPositionHandler(idx)} name="remove" color="red" />
              )}
            </div>
          </>
        );
      })}
    </div>
  );
};

export default withTranslation()(TailwindEventNewModelPositionComponent);
